export default __webpack_public_path__ + "static/chest-45ddf4ce4484b970a494dc42c6531352.png";